const checkAttributes = (attributeMatch, baseAttributes, user) => {
    const results = [];
    Object.entries(attributeMatch).forEach(([key, actionCheck]) => {
        let attributes = baseAttributes;
        if (user && baseAttributes.userAttributes && baseAttributes.userAttributes[user]) {
            attributes = baseAttributes.userAttributes[user];
        }
        if (attributes[key] !== undefined) {
            if (actionCheck.op) {
                switch (actionCheck.op) {
                    case '=': {
                        // eslint-disable-next-line eqeqeq
                        results.push(attributes[key] == actionCheck.val);
                        break;
                    }
                    case '!=': {
                        // eslint-disable-next-line eqeqeq
                        results.push(attributes[key] != actionCheck.val);
                        break;
                    }
                    case '>': {
                        results.push(attributes[key] > actionCheck.val);
                        break;
                    }
                    case '<': {
                        results.push(attributes[key] < actionCheck.val);
                        break;
                    }
                    case '<=': {
                        results.push(attributes[key] <= actionCheck.val);
                        break;
                    }
                    case '>=': {
                        results.push(attributes[key] >= actionCheck.val);
                        break;
                    }
                    case 'range': {
                        results.push(attributes[key] >= actionCheck.val[0] && attributes[key] <= actionCheck.val[1]);
                        break;
                    }
                    case 'in': {
                        results.push(actionCheck.val.includes(attributes[key]));
                        break;
                    }
                    default: {
                        results.push(attributes[key] !== undefined);
                    }
                }
            }
        }
        else {
            results.push(false);
        }
    });
    return results.filter((item) => item).length === results.length;
};
export { checkAttributes, };
